<template>
  <Sidebar v-if="authStore.isAuthenticated && authStore.isAuthorized" />

  <div v-if="authStore.isAuthenticated" class="d-flex flex-column w-100">
    <Navbar />

    <div v-if="!authStore.isAuthorized" class="alert alert-danger m-3">Sie haben nicht die Berechtigung, um diese Seite zu zugreifen.</div>

    <div v-else id="main-content" class="p-3 pt-1">
      <router-view />
    </div>
  </div>

  <LoadingOverlay v-if="loading" />
</template>

<script setup lang="ts">
  //#region Imports
  import { computed, onMounted } from 'vue';

  import { useCommonStore } from '@/stores/commonStore';
  import { useAuthStore } from '@/stores/authStore';

  import Sidebar from '@/components/Menues/Sidebar.vue';
  import Navbar from './components/Menues/Navbar.vue';
  import LoadingOverlay from './components/LoadingOverlay.vue';
  //#endregion

  const commonStore = useCommonStore();
  const authStore = useAuthStore();

  const loading = computed(
    () =>
      commonStore.status.getApplicationLoading ||
      commonStore.status.createApplicationLoading ||
      commonStore.status.updateApplicationLoading ||
      commonStore.status.deleteApplicationLoading ||
      commonStore.status.getBenutzerLoading ||
      commonStore.status.createBenutzerLoading ||
      // commonStore.status.updateBenutzerLoading ||
      // commonStore.status.deleteBenutzerLoading ||

      commonStore.status.getListeLoading ||
      commonStore.status.createListeLoading ||
      commonStore.status.updateListeLoading ||
      commonStore.status.deleteListeLoading ||
      commonStore.status.getUnternehmenLoading ||
      commonStore.status.createUnternehmenLoading ||
      commonStore.status.updateUnternehmenLoading ||
      commonStore.status.deleteUnternehmenLoading
  );

  onMounted(async () => {
    // if (authStore.isAuthenticated && authStore.isAuthorized && authStore.user == null) {
    //   await authStore.getLoggedInUser();
    // }
  });
</script>

<style lang="scss">
  @import './assets/sass/main.scss';
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    min-height: 100vh;
    display: flex;
    background: rgb(242, 243, 248) !important;
  }

  #main-content {
    position: relative;
    background: rgb(242, 243, 248);
  }

  /* Custom scrollbar styling */
  /* Webkit-based browsers (Chrome, Safari) */
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

  /* Firefox */
  body {
    scrollbar-width: thin;
    scrollbar-color: #888 #f1f1f1;
  }
</style>
